module.exports = __webpack_public_path__ + "img/bing3.7c8c87d5.png";